import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const EditMaterialBrand = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [material, setMaterial] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.put("update-material/" + id, values)
    if (response.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const materialResp = await api.get("material/" + id)
    setMaterial(materialResp.data.data[0])
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Material Brand</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/materials" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <div className="mb-3">
              <AvField
                name="materialName"
                label="Material Brand Name"
                value={material.materialName}
                className="form-control"
                type="text"
                required
              />
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Brand is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Material </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditMaterialBrand
